const AdminHomePage = () => {
  return (
    <section className='admin-home-sec m-4'>
      <div className='admin-home-div  block'>
        <div className='box demo-period p-5'>
          <h3 className='is-size-7'>Your Trial will Expire In 10 Days</h3>
        </div>
        <div className='box'></div>
        <div className='box'></div>
      </div>
    </section>
  );
};

export default AdminHomePage;
